import React from 'react';
import Header from '../components/Header';
import SEO from '../components/SEO';

const LeadershipMirrorProductPage = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <SEO 
        title="Leadership Mirror™ Assessment Nigeria | Leadership Narrative Feedback Lagos"
        description="Take the Leadership Mirror™ assessment online. A deeply personal leadership narrative revealing your posture, patterns, shadow side, and developmental edge. More than feedback, a mirror for self-discovery."
        keywords="Leadership Mirror Nigeria, leadership assessment Lagos, 360 feedback Nigeria, executive assessment Africa, leadership self-assessment, leadership narrative"
        canonical="https://impactasportal.com/product/leadership-mirror"
      />
      <Header />
      
      {/* Main Content - Iframe Container */}
      <main className="flex-1 pt-20">
        <div className="w-full h-[calc(100vh-80px)]">
          <iframe
            src="https://impactasportal.com/product/leadership-mirror?embed=true"
            title="Leadership Mirror™ - Impact AS Plus"
            className="w-full h-full border-0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
            allowFullScreen
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-downloads allow-modals allow-popups-to-escape-sandbox"
          />
        </div>
      </main>
    </div>
  );
};

export default LeadershipMirrorProductPage;
